var __default__ = {root:'m_f8d312f2',symbolGroup:'m_61734bb7',starSymbol:'m_5662a89a',input:'m_211007ba',label:'m_21342ee4',symbolBody:'m_fae05d6a'};
export default __default__;